
import { supabase } from '@/integrations/supabase/client';

export const resolveAlert = async (alertId: string): Promise<void> => {
  try {
    const { error } = await supabase
      .from('schedule_alerts')
      .update({ is_resolved: true })
      .eq('id', alertId);
    
    if (error) {
      console.error('Error resolving alert:', error);
      throw error;
    }
  } catch (error) {
    console.error('Error in resolveAlert:', error);
    throw error;
  }
};
